import { AnyAction } from 'redux';

import { SET_MOBILE } from './actions';

// Reducer
export type LayoutState = {
  isMobile: boolean | undefined;
};

const defaultState: LayoutState = {
  isMobile: undefined,
};
export const layoutReducer = (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case SET_MOBILE: {
      const isMobile = action.isMobile;
      return { ...state, isMobile };
    }
    default:
      return state;
  }
};
